import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Resolves once msalInstance.initialize() completes.
 * Await this in httpClient interceptor before acquiring tokens.
 */
export const msalReady = msalInstance.initialize();